<div class="company-bar bg--navy-600 position-relative gap-2">

    @if(company()){
        <div class="h-100 position-relative d-flex flex-row">

            @for (child of companyNavData()?.children; track $index) {

                @let childNavigation = featureFlagsService.getNavigationFlag(child.id);

                <!-- Change Company will be a normal link if companies() is empty, otherwise it will be show a modal -->
                @if(child.name == 'Change Company'){

                    <app-modal [title]="child.name" [(visible)]="companySelectVisible"> 
                        <a #modalShow ngProjectAs="modal-show" class="company-nav-item hoverable text-decoration-none" [tooltip]="child.name" tooltip-placement="bottom">
            
                            <div class="w-100 d-flex flex-row justify-content-center align-items-center text-decoration-none p-3">
            
                                <fa-icon [icon]="['fas', child.icon ?? 'box']"/>
                                <!-- <span class="text-decoration-none font-size-09rm">{{child.name}}</span> -->
            
                            </div>
            
                        </a>

                        <div #modalContent ngProjectAs="modal-content" class="d-flex flex-grow-1" style="min-height: 40vh;">

                            <app-company-list
                                [features]="features().CompanyList"
                                [rowClickBehaviour]="'navigate'"
                                [targetLocation]="'stay'"
                                [(filter-params)]="filterParams"
                                [get-data]="getCompanies"
                            />
                    
                        </div>

                    </app-modal>

                }
                @else if(child.id != Navigation.CompanySettingsUserAccess && child.id != Navigation.CompanySettingsRoles && child.id != Navigation.CompanySettings) {

                    @if(childNavigation == undefined || childNavigation.enabled){

                        <a class="company-nav-item hoverable text-decoration-none" [tooltip]="child.name" tooltip-placement="bottom" [routerLink]="getCompanyChildUrl(child.url ?? [])" [routerLinkActive]="['active']">

                            <div class="w-100 d-flex flex-row justify-content-center align-items-center text-decoration-none p-3">

                                <fa-icon [icon]="['fas', child.icon ?? 'box']"/>
                                <!-- <span class="text-decoration-none font-size-09rm">Settings</span> -->

                            </div>

                        </a>

                    }

                }

            }

            <a class="border-left company-nav-item company-nav-name hoverable text-decoration-none" [tooltip]="'Company'" tooltip-placement="bottom" [routerLink]="getCompanyChildUrl(['settings'])" [routerLinkActive]="['active']">

                <div class="w-100 d-flex flex-row justify-content-center align-items-center text-decoration-none gap-3">

                    <span class="m-0 p-0 font-tertiary position-relative text-single-line">{{company()?.fullName}}</span>   
                    <app-company-image [company]="company()" [size]="'thiny'"/>

                </div>

            </a>

        </div>
        
    }
    @else{
        <a class="h-100 position-relative d-flex flex-row justify-content-center align-items-center text-decoration-none" [tooltip]="'Company Select'" tooltip-placement="bottom" [routerLink]="['/company','select']" [routerLinkActive]="['active']">
            <span class="font-semibold font-tertiary color--white-100-40 p-3">No Company Selected</span>
        </a>
    }

    @if(organisation()){

        <a class="border-left company-nav-item p-3 text-decoration-none hoverable"
            [tooltip]="'Organisation'"
            [tooltip-placement]="'bottom'"
            [routerLink]="['organisation', 'settings']">

            <div class="w-100 d-flex flex-row justify-content-center align-items-center text-decoration-none">

                <app-organisation-image [organisation]="organisation()" [size]="'thiny'" [routerLinkActive]="['shadow-accent', 'shadow-medium-inset']"/>

            </div>

        </a>

    }

</div>